import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
  fetchMyself,
} from 'actions/myself';
import { setTab } from 'actions/subtabs';

import GeneralContainer from 'components/GeneralContainer';
import Loading from 'components/Loading';
import Myself from 'components/Myself';

class MyselfTab extends React.Component {
  static displayName = 'MyselfTab'

  /**
   * [componentDidMount description]
   * @return {[type]} [description]
   */
  componentDidMount = () => {
    const { dispatch, hasFetched, isFetching } = this.props;
    // If we have no data (because the API janked out), and we aren't
    // fetching, then retrieve data
    if (!(hasFetched || isFetching)) {
      dispatch(fetchMyself());
    }
    // Make sure that we set the subtab (we may be loading straight into /myself)
    dispatch(setTab({ tab: 'myself', subtab: 'myself' }));
  }


  /**
   * Render
   * @return {Object}
   */
  render() {
    const { isFetching } = this.props;

    return (
      <GeneralContainer loading={isFetching}>
        {isFetching ? <Loading key="loading" /> : <Myself key="myself" />}
      </GeneralContainer>
    );
  }
}

MyselfTab.displayName = 'MyselfTab';

MyselfTab.propTypes = {
  dispatch: PropTypes.func.isRequired,
  hasFetched: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ myself: { isFetching, hasFetched } }) => ({
  hasFetched,
  isFetching,
});

export default withRouter(connect(mapStateToProps)(MyselfTab));
